import {
  Component,
  HostListener,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-visit-us',
  templateUrl: './visit-us.component.html',
  styleUrls: ['./visit-us.component.css']
})
export class VisitUsComponent implements OnInit, AfterViewInit {
  // Merdeka 118 Video
 @ViewChild('merdekaVideo', { static: false }) merdekaVideo!: ElementRef<HTMLVideoElement>;

  // FAQ (Stores currently open FAQ number; null means all FAQs are closed)
  openFaq: number | null = null;

  constructor() {}

  // Component Lifecycle
  ngOnInit(): void {
    this.checkReveal();
  }

  ngAfterViewInit(): void {
    this.setupMerdekaVideo();
  }

  // Merdeka Video Methods
  setupMerdekaVideo(): void {
    if (!this.merdekaVideo) return;

    const video = this.merdekaVideo.nativeElement;

    // Force video to be completely silent
    video.muted = true;
    video.defaultMuted = true;
    video.volume = 0;
    video.loop = true;

    // Try to start video automatically
    this.playMerdekaVideo(video);

    // Make sure it remains muted whenever playback starts
    video.addEventListener('play', () => {
      video.muted = true;
      video.volume = 0;
    });

    // Extra protection when video reaches the end
    video.addEventListener('ended', () => {
      video.muted = true;
      video.volume = 0;
      video.currentTime = 0;
      this.playMerdekaVideo(video);
    });
  }

  playMerdekaVideo(video: HTMLVideoElement): void {
    video.muted = true;
    video.volume = 0;

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // Browser blocked autoplay; video remains muted.
      });
    }
  }

  // FAQ Toggle
  toggleFaq(faqNumber: number): void {
    this.openFaq = this.openFaq === faqNumber ? null : faqNumber;
  }

  // Scroll Animations
  @HostListener('window:scroll')
  onScroll(): void {
    this.checkReveal();
  }

  checkReveal(): void {
    const elements = document.querySelectorAll('.reveal');
    const windowHeight = window.innerHeight;

    elements.forEach((el: any) => {
      const position = el.getBoundingClientRect().top;
      if (position < windowHeight - 100) {
        el.classList.add('active');
      }
    });
  }

  // Smooth Scroll
  scrollTo(element: HTMLElement): void {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}